/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder for a organization profile.
 */

import Grid from "../../../../02-atoms/06-layout/04-grid";
import Cell from "../../../../02-atoms/06-layout/04-grid/01-cell";
import Main from "../../../../02-atoms/06-layout/09-main";
import styles from "./galleryPlaceholder.module.scss";

export const OrganizationGalleryPlaceholder = () => (
  <Main>
    <Grid
      gap={6}
      alignItems="center"
      gridAutoFlow="dense"
      className={styles.grid}
    >
      <Cell gridColumn={["span 2"]} gridRow={[1, "span 2"]}>
        <div
          style={{
            height: "250px",
            width: "100%",
            background: "#dedede",
          }}
        />
      </Cell>
      <Cell gridColumn={[1, 3]} gridRow={[2, 1]}>
        <div
          style={{
            height: "115px",
            width: "100%",
            background: "#dedede",
          }}
        />
      </Cell>
      <Cell gridColumn={[1, 3]} gridRow={[3, 2]}>
        <div
          style={{
            height: "115px",
            width: "100%",
            background: "#dedede",
          }}
        />
      </Cell>
      <Cell gridColumn={[2, 4]} gridRow={["span 2", "span 2"]}>
        <div
          style={{
            height: "250px",
            width: "100%",
            background: "#dedede",
          }}
        />
      </Cell>
      <Cell gridColumn={"span 2"} gridRow={[4, "span 2"]}>
        <div
          style={{
            height: "250px",
            width: "100%",
            background: "#dedede",
          }}
        />
      </Cell>
    </Grid>
  </Main>
);
export default OrganizationGalleryPlaceholder;
